const supportedLanguages = [
	'en',
	'th',
	'pl',
	'fr',
	'pt',
	'km'
]

export default supportedLanguages